export default "__VITE_ASSET__BNSfe9jM__"